import i18n from "@/i18n";
// CALENDAR-ABSENCES-V1 — calendar-cell absence labels and manager actions.
import { AlertTriangle, Plus } from "lucide-react";
import { absenceLabel } from "./absenceShared";

const CHIP = "inline-flex items-center gap-0.5 rounded-full border border-amber-300 "
    + "bg-amber-50 px-2 py-0.5 text-[10px] text-amber-800";
const WARN = "Shift and absence on the same date";

function ShiftWarning({ testId }) {
    return (
        <span data-testid={testId} role="img" aria-label={i18n.t("wf.AbsenceChip.WARN", WARN)} title={i18n.t("wf.AbsenceChip.WARN", WARN)}>
            <AlertTriangle aria-hidden="true" className="h-2.5 w-2.5 text-amber-700" />
        </span>
    );
}

export function AbsenceLabel({ absence, testId, warnTestId, hasShift }) {
    return (
        <div data-testid={testId} data-absence-type={absence.absence_type} className={`mt-1 ${CHIP}`}>
            {absenceLabel(absence.absence_type)}
            {hasShift && <ShiftWarning testId={warnTestId} />}
        </div>
    );
}

export function CellAbsenceControls({ view, employeeId, date, absences, hasShift, canAdd, onOpen }) {
    const stop = (e) => e.stopPropagation();
    const id = `${employeeId}-${date}`;
    if (!absences.length && !canAdd) return null;
    return (
        <div className="mt-0.5 flex flex-wrap items-center justify-center gap-0.5"
            onClick={stop} onMouseDown={stop} onPointerDown={stop} onKeyDown={stop}
            data-testid={`workforce-${view}-absence-controls-${id}`}>
            {absences.map((a) => (
                <button key={a.absence_id} type="button" className={`${CHIP} hover:bg-amber-100`}
                    data-testid={`workforce-${view}-absence-${id}`}
                    data-absence-id={a.absence_id} data-absence-type={a.absence_type}
                    onClick={() => onOpen({ mode: "edit", employeeId, absence: a, date })}>
                    {absenceLabel(a.absence_type)}
                    {hasShift && <ShiftWarning testId={`workforce-${view}-absence-shift-warning-${id}`} />}
                </button>
            ))}
            {canAdd && (
                <button type="button" title={i18n.t("wf.absenceChip.addAbsence", "Add absence")} aria-label={i18n.t("wf.absenceChip.addAbsence", "Add absence")}
                    className="rounded p-0.5 text-neutral-400 opacity-0 transition-opacity
                               hover:text-amber-700 group-hover:opacity-100 focus:opacity-100"
                    data-testid={`workforce-${view}-absence-add-${id}`}
                    onClick={() => onOpen({ mode: "add", employeeId, date })}>
                    <Plus className="h-3 w-3" aria-hidden="true" />
                </button>
            )}
        </div>
    );
}
